<script setup>
const { level = 'h2' } = defineProps({
    level: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <component
        :is="level"
        class="mb-4 font-medium"
        :class="{
            'text-xl': level === 'h2',
            'text-lg': level === 'h3',
        }"
    >
        <slot />
    </component>
</template>
